import { SOFTPULL_MODULE } from '~/constants/common/MfeModules';
import { useIsNative } from '~/context/common/DeviceContext';
import { selectIsMfeReady, useMfeLoadStore } from '~/state/common/MfeLoadState';

const selectIsSoftpullMfeReady = selectIsMfeReady(SOFTPULL_MODULE);

/**
 * Native webviews never mount the web SoftPullMfeModal (see SoftpullModal.tsx),
 * so SOFTPULL_MODULE's readiness never resolves there — treat native as always ready
 * so these CTAs aren't permanently disabled outside the web MFE flow.
 */
export default function useSoftpullMfeReady() {
  const isNative = useIsNative();
  const isWebMfeReady = useMfeLoadStore(selectIsSoftpullMfeReady);

  return isNative || isWebMfeReady;
}
